import FormError from '@/components/FormError/formError';
import GoogleRecaptcha from '@/components/GoogleReCaptcha';
import { websiteEnv } from '@/constants/website-env';
import { GET_CART_DETAILS_QUERY } from '@/hooks/SignIn/signIn.gql';
import { useSignIn } from '@/hooks/SignIn/useSignIn';
import { isRequired, validateEmail2 } from '@/util/formValidators';
import { ErrorMessage } from '@hookform/error-message';
import clsx from 'clsx';
import Link from 'next/link';
import { useState } from 'react';
import { useForm } from 'react-hook-form';

const SignIn = props => {
  const { setDefaultUsername = () => {}, showCreateAccount = () => {}, showForgotPassword = () => {} } = props;

  const hookFormMethods = useForm({
    defaultValues: {
      email: '',
      password: '',
    },
  });
  const [passwordType, setPasswordType] = useState('password');

  const talonProps = useSignIn({
    getCartDetailsQuery: GET_CART_DETAILS_QUERY,
    setDefaultUsername,
    showCreateAccount,
    showForgotPassword,
  });

  const { errors, handleSubmit, isBusy, isSigningIn, recaptchaWidgetProps } = talonProps;

  return (
    <div>
      <form
        onSubmit={hookFormMethods.handleSubmit(values => {
          handleSubmit({
            values,
          });
        })}
        className='mb-2.5'
      >
        <div>
          <div>
            <span className='text-e73635'>*</span>
            <span className='ml-1 text-[15px] leading-5'>Email</span>
          </div>
          <input
            {...hookFormMethods.register('email', {
              validate: validateEmail2,
            })}
            className='mt-1.5 h-10 w-full border-1 border-solid border-E7DED5 px-[15px] text-[15px]'
          />
          <ErrorMessage
            name='email'
            errors={hookFormMethods.formState.errors}
            render={({ message }) => {
              return (
                <div className='relative'>
                  <span className='absolute text-xs text-e73635'>{message}</span>
                </div>
              );
            }}
          />
        </div>

        <div className='mt-[22px]'>
          <div className='flex items-center justify-between'>
            <span>
              <span className='text-e73635'>*</span>
              <span className='ml-1 text-[15px] leading-5'>Password</span>
            </span>
            <Link
              href='/forgot-password'
              className='text-[13px] leading-4 text-8B857D lg_underline'
            >
              Forgot Your Password?
            </Link>
          </div>
          <div className='relative mt-1.5'>
            <input
              {...hookFormMethods.register('password', {
                validate: isRequired,
              })}
              type={passwordType}
              className={clsx(
                ' h-10 w-full border-1 border-solid border-E7DED5 pl-[15px] pr-10',
                passwordType === 'password' ? ' font-serif text-xl leading-none tracking-[.1em]' : 'text-sm',
              )}
            />
            <button
              onClick={() => {
                setPasswordType(x => (x === 'password' ? 'text' : 'password'));
              }}
              className='absolute right-4 top-1/2 -translate-y-1/2'
              type='button'
            >
              {passwordType === 'password' ? eyeOffIcon : eyeIcon}
            </button>
          </div>
          <ErrorMessage
            name='password'
            errors={hookFormMethods.formState.errors}
            render={({ message }) => {
              return (
                <div className='password'>
                  <span className='absolute text-xs text-e73635'>{message}</span>
                </div>
              );
            }}
          />
        </div>

        <GoogleRecaptcha {...recaptchaWidgetProps} />
        <button
          type='submit'
          className={clsx(
            'mt-[30px]',
            'h-12 w-full',
            'rounded-[3px]',
            'text-[15px] font-medium leading-none ',
            'aw-primary-btn',
          )}
          disabled={isBusy}
        >
          {isSigningIn ? 'LOADING...' : websiteEnv.isUnitedKingdom ? 'LOG IN' : 'LOGIN'}
        </button>
      </form>
      <FormError
        allowErrorMessages
        errors={Array.from(errors.values())}
      />
    </div>
  );
};

const eyeIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    className='h-auto w-5'
  >
    <path d='M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8' />
    <circle
      cx='12'
      cy='12'
      r='3'
    />
  </svg>
);
const eyeOffIcon = (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='24'
    height='24'
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    strokeWidth='2'
    viewBox='0 0 24 24'
    className='h-auto w-5'
  >
    <path d='M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9 9 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22' />
  </svg>
);

export default SignIn;
